import React from 'react'
import { motion } from 'motion/react'

export default function ProgramSignupAuraBackground() {
  return (
    <div
      className="pointer-events-none absolute inset-0 z-0 overflow-hidden"
      aria-hidden="true"
    >
      <motion.div
        className="absolute rounded-full"
        style={{
          width: 500,
          height: 500,
          top: '-15%',
          right: '-25%',
          background:
            'radial-gradient(circle, rgba(160,50,220,0.55) 0%, rgba(160,50,220,0) 65%)',
          filter: 'blur(40px)',
        }}
        animate={{
          x: [0, -80, 50, -30, 0],
          y: [0, 60, -50, 80, 0],
          scale: [1, 1.3, 0.8, 1.2, 1],
        }}
        transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute rounded-full"
        style={{
          width: 450,
          height: 450,
          top: '25%',
          left: '-20%',
          background:
            'radial-gradient(circle, rgba(175,75,251,0.6) 0%, rgba(175,75,251,0) 65%)',
          filter: 'blur(35px)',
        }}
        animate={{
          x: [0, 100, -50, 70, 0],
          y: [0, -80, 60, -30, 0],
          scale: [1, 0.8, 1.35, 0.85, 1],
        }}
        transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute rounded-full"
        style={{
          width: 350,
          height: 350,
          bottom: '0%',
          left: '25%',
          background:
            'radial-gradient(circle, rgba(100,50,255,0.5) 0%, rgba(100,50,255,0) 65%)',
          filter: 'blur(30px)',
        }}
        animate={{
          x: [0, -60, 80, -40, 0],
          y: [0, -90, 30, -60, 0],
          scale: [1, 1.3, 0.7, 1.25, 1],
        }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute rounded-full"
        style={{
          width: 400,
          height: 400,
          top: '0%',
          left: '5%',
          background:
            'radial-gradient(circle, rgba(130,40,200,0.45) 0%, rgba(130,40,200,0) 65%)',
          filter: 'blur(45px)',
        }}
        animate={{
          x: [0, 60, -80, 40, 0],
          y: [0, 50, -70, 50, 0],
          scale: [1, 1.25, 0.85, 1.15, 1],
        }}
        transition={{ duration: 7, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute rounded-full"
        style={{
          width: 420,
          height: 420,
          bottom: '10%',
          right: '-10%',
          background:
            'radial-gradient(circle, rgba(54,0,220,0.5) 0%, rgba(54,0,220,0) 65%)',
          filter: 'blur(35px)',
        }}
        animate={{
          x: [0, -70, 50, -40, 0],
          y: [0, 70, -50, 35, 0],
          scale: [1, 0.85, 1.3, 0.9, 1],
        }}
        transition={{ duration: 5.5, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        className="absolute rounded-full"
        style={{
          width: 300,
          height: 300,
          top: '40%',
          left: '30%',
          background:
            'radial-gradient(circle, rgba(120,20,180,0.4) 0%, rgba(120,20,180,0) 60%)',
          filter: 'blur(50px)',
        }}
        animate={{
          x: [0, 40, -60, 30, 0],
          y: [0, -40, 50, -25, 0],
          scale: [0.8, 1.4, 0.75, 1.3, 0.8],
          opacity: [0.6, 1, 0.5, 0.9, 0.6],
        }}
        transition={{ duration: 3.5, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  )
}
